import { render, staticRenderFns } from "./ExtraBranchesModal.vue?vue&type=template&id=520838aa&"
import script from "./ExtraBranchesModal.vue?vue&type=script&lang=js&"
export * from "./ExtraBranchesModal.vue?vue&type=script&lang=js&"
import style0 from "./ExtraBranchesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports